import type { FC, HTMLAttributes } from "react";

import { useLocatorTranslations } from "@locators/components/shared/hooks/useLocatorTranslations";
import { useStoreLocatorContext } from "@locators/components/shared/hooks/useStoreLocatorContext";

import { AlertBanner } from "@jti/core-components/components/AlertBanner";

const noStoresPopupTypes = ["search", "filters", "location"] as const;
type NoStoresPopupType = (typeof noStoresPopupTypes)[number];

type NoStoresPopupProps = {
  type: string;
} & HTMLAttributes<HTMLDivElement>;

export const NoStoresPopup: FC<NoStoresPopupProps> = ({ type, ...rest }) => {
  const { __ } = useLocatorTranslations();
  const { handleMapExpansion, handleResetFilters } = useStoreLocatorContext();
  const typeValues = {
    search: {
      title: __("store_locator.noStoresPopup.searchTitle"),
      description: __("store_locator.noStoresPopup.searchDescription"),
      cta: __("store_locator.noStoresPopup.searchCta"),
    },
    filters: {
      title: __("store_locator.noStoresPopup.filtersTitle"),
      description: __("store_locator.noStoresPopup.filtersDescription"),
      cta: __("store_locator.noStoresPopup.filtersCta"),
    },
    location: {
      title: __("store_locator.noStoresPopup.locationTitle"),
      description: __("store_locator.noStoresPopup.locationDescription"),
      cta: __("store_locator.noStoresPopup.locationCta"),
    },
  };
  const popupType: NoStoresPopupType = noStoresPopupTypes.includes(type as NoStoresPopupType)
    ? (type as NoStoresPopupType)
    : "search";

  const handleClickButton = () => {
    if (popupType === "filters") {
      handleResetFilters();
    } else {
      handleMapExpansion?.();
    }
  };

  return (
    <div {...rest}>
      <AlertBanner
        data-testid="info-banner-wrapper"
        tone="info"
        title={typeValues[popupType].title}
        description={typeValues[popupType].description}
        actions={[{ label: typeValues[popupType].cta, onClick: handleClickButton }]}
      />
    </div>
  );
};
